import { Anchor } from "../pb/pb"
import * as langs from "../constants/langs"
import * as url from "../utils/url"
import { getConfigFromPayUrl } from "../api/store-config"

export interface QueryRedirectUrlParams {
  appId: string
  anchorId: string
}
/**
 * 查询主播页匠跳转地址
 * @param params
 * @returns
 */
export function queryRedirectUrl(params: QueryRedirectUrlParams) {
  return Anchor.Anchor2ShopInfo(
    {
      appId: params.appId,
      anchorId: params.anchorId,
      system: "midas"
    },
    {
      openid: "openid",
      openkey: "openkey",
      session_id: "hy_gameid",
      session_type: "st_dummy",
      offer_id: "1450019044"
    }
  )
}

export function queryLivePagedooUrlMap() {
  const storeConfigEnv = url.getParam("store_config_env")
  return Promise.resolve().then(() => {
    if (+storeConfigEnv > 0) {
      return getConfigFromPayUrl({
        configUrl: `//sandbox.pay.qq.com${langs.LIVE_PAGEDOO_URL_MAP}`,
        configUrlParam: {}
      })
    } else {
      return Promise.resolve().then(() => {
        return window?.["__midasStaticConfig_live_pagedoo_url_map"]
      })
    }
  })
}
